import { render, staticRenderFns } from "./complete-task-dialog.vue?vue&type=template&id=0bb2a8c2&"
import script from "./complete-task-dialog.vue?vue&type=script&lang=js&"
export * from "./complete-task-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports